import { connect } from 'react-redux';
import { updateNft, deleteNft } from '../redux/actions';
const mapDispatchToProps = {
    updateNft,
    deleteNft
};
export default connect(null, mapDispatchToProps);
